module.exports = __webpack_public_path__ + "static/media/4Pin.f77f1139.svg";